/* Captable - Jurídico */
import * as captableStore from './store'

export function captableModule({ store }) {
  store.registerModule('captable', { ...captableStore, namespaced: true })
}
